// extracted by mini-css-extract-plugin
export default {"confirmationNumber":"thank_panel_confirmationNumber__iPg2G","container":"thank_panel_container__RlH4-","panel":"thank_panel_panel__OhZwH"};